import request from 'src/api'
import { clientFunctions } from 'packs/clients/functions'
import { lockButton, unlockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import { addToast } from 'src/toasts'
import { camelize } from 'src/misc'
import { showGoogleMap } from 'src/googleMap'
import initDatatableChrome from 'src/datatableChrome'
import onIndexRefresh from 'src/indexRefresh'

export default () => {
  clientFunctions()

	// datatable init
  let clientsDatatable = $('#clients-datatable').DataTable({
    "language": {
      url: "/datatable_i18n"
    },
    "pageLength": (localStorage.getItem('clientsIndexPageLength') || 25),
    "processing": true,
    // TODO.md F-123. A control COLUMN, not Responsive's default inline control. `'inline'` puts the expand
    // control in the FIRST cell — the same cell as the record's own link — so at phone width the two shared
    // one tap target and tapping the arrow opened the record. `target: 0` is the column added by
    // `shared/_datatable_control_th`.
    // ⚠️ The `dtr-control` className below is NOT optional: `Responsive._controlClass` (dataTables.responsive.js:674,
    // v2.5.1) runs its body only when `details.type === 'inline'`, so under `'column'` nothing adds it.
    // 🚨 **TODO.md F-123 follow-up. An EXPLICIT sort, because the control column silently removed it.**
    // DataTables' default is `aaSorting: [[0, 'asc']]` (`jquery.dataTables.js:10285`) and none of these
    // packs set `order`, so inserting the non-orderable control column at index 0 made the request carry
    // `order[0][column]=0`. `_fnSortFlatten` does not filter on `bSortable`, `ajax-datatables-rails` adds a
    // sort clause only `if column.orderable?` (`orm/active_record.rb:15`), and the resulting
    // `order(Arel.sql(''))` is dropped by Rails 8.1's `compact_blank` — verified:
    // `Customer.order(Arel.sql("")).limit(25).to_sql` has no ORDER BY at all.
    // ⚠️ **The lost alphabetical default was the visible half; the unstable paging was the dangerous one** —
    // server-side `LIMIT/OFFSET` with no ORDER BY can repeat or skip rows between pages.
    // 📌 Found by `/code-review` after the branch had already merged, which is why `spec/config/
    // datatable_responsive_spec.rb` now asserts an explicit non-zero `order` as part of the same rule.
    "order": [[1, "asc"]],
    "responsive": { "details": { "type": "column", "target": 0 } },
    "serverSide": true,
    "ajax": {
      "url": $('#clients-datatable').data('source')
    },
    "columns": [
      { "data": "control", "orderable": false, "searchable": false, "className": "dtr-control" },
      { "data": "company_name" },
      { "data": "business_id" },
      { "data": "status" },
      { "data": "contact_person" },
      { "data": "phone" },
      { "data": "email" },
      { "data": "address" },
      { "data": "actions", "orderable": false, "className": "all" }
    ],
    initComplete(settings, json) {
      initDatatableChrome('clients-datatable')

  	}
  })

  // T-102 / T-108 / U-48: reload this page's table when a save says so. The `off()`/`on()` pair and
  // `resetPaging: false` live in `src/indexRefresh` — five packs carried a copy of both.
  onIndexRefresh('clientsIndex', clientsDatatable)

  $('#content').on('change', "[name='clients-datatable_length']", function() {
    localStorage.setItem('clientsIndexPageLength', $(this).val())
  })

  $('.clear-button').on('click', function() {
    $('.clear-button').addClass('d-none')
    clientsDatatable.search('').draw()
  })

  $('#content').on('click', '#add_client', function() {
    lockButton('#add_client')
    offcanvasRight.show()
    $.getScript('/clients/new')
  })

  $('#content').on('click', '.show-googlemap', function(event) {
    $(this).prop("disabled", true)

    const companyName = $(this).data('company_name')
    const streetName = $(this).data('street_name')
    const postCode = $(this).data('post_code')
    const town = $(this).data('town')
    const country = $(this).data('country')
    const totalAddress = (streetName + ", " + postCode + " " + town).trim()
    if (totalAddress.length > 1) {
      let title = companyName
      showGoogleMap(mainModal, title, [{ address: totalAddress + ', ' + country, title: totalAddress }])
    } else {
      addToast(I18n.t("errors.no_address"), 'alert')
    }

    $(this).prop("disabled", false)
  })
}
